import {getDateFromIsoString} from '@shared/api';
import {UserRating} from '../types';
import {UserRatingOnBackend} from './backendTypes';

export const mapUserRatingFromBackend = ({
  user_id,
  username,
  rating,
  comment,
  user_agent,
  created_at,
}: UserRatingOnBackend): UserRating => ({
  userId: user_id,
  username,
  rating,
  comment: comment ?? '',
  userAgent: user_agent ?? '',
  created: getDateFromIsoString(created_at),
});
